import service from "@/api/service";
import {
  GetRequest,
  SortRequest,
  DeleteRequest,
  DetailRequest,
  RegisterRequest
} from "@/api/cassette/request";
import {
  GetResponse,
  DetailResponse,
  RegisterResponse
} from "@/api/cassette/response";
import { CommonResponse } from "@/api/response";

/**
 * カセット一覧APIをコールします。
 *
 * @param getRequest カセット検索のリクエストボディ
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-cassette", getRequest);
  return response.data as GetResponse;
}

/**
 * カセット詳細情報取得APIをコールします。
 *
 * @param detailRequest カセット詳細情報取得のリクエストボディ
 * @return DetailResponse
 */
export async function detail(detailRequest: DetailRequest) {
  const response = await service.post("/get-cassette-detail", detailRequest);
  return response.data as DetailResponse;
}

/**
 * カセット情報登録更新APIをコールします。
 *
 * @param registerRequest カセット情報登録更新のリクエストボディ
 * @return RegisterResponse
 */
export async function register(registerRequest: RegisterRequest) {
  const response = await service.post("/regist-cassette", registerRequest);
  return response.data as RegisterResponse;
}

/**
 * カセット並び替え登録更新APIをコールします。
 *
 * @param sortRequest
 * @return CommonResponse
 */
export async function sort(sortRequest: SortRequest) {
  const response = await service.post("/sort-cassette", sortRequest);
  return response.data as CommonResponse;
}

/**
 * カセット情報削除APIをコールします。
 *
 * @param deleteRequest
 * @return CommonResponse
 */
export async function deleteOne(deleteRequest: DeleteRequest) {
  const response = await service.post("/delete-cassette", deleteRequest);
  return response.data as CommonResponse;
}
